/**
 *
 *
 *
 *
 */

class VoiceTracker {
    private startTime: number | null = null;
    private pauseTime: number | null = null;
    private accumulatedDuration: number = 0;
    private isPaused: boolean = false;
    private productsCount: number | null = null;

    /**
 *
 */
    start(): void {
        this.startTime = Date.now();
        this.pauseTime = null;
        this.accumulatedDuration = 0;
        this.isPaused = false;
    }

    /**
 *
 */
    pause(): void {
        if (this.isPaused || !this.startTime) {
            return;
        }

        /*                                                                          */
        const now = Date.now();
        const sessionDuration = this.pauseTime ? now - this.pauseTime : now - this.startTime;
        this.accumulatedDuration += sessionDuration;

        this.pauseTime = now;
        this.isPaused = true;
    }

    /**
 *
 */
    resume(): void {
        if (!this.isPaused || !this.pauseTime) {
            return;
        }

        /*                                                                             */
        this.pauseTime = Date.now();
        this.isPaused = false;
    }

    /**
 *
 *
 */
    end(): [number, number | undefined] {
        if (!this.startTime) {
            return [0, this.productsCount || undefined];
        }

        let totalDuration = this.accumulatedDuration;

        /*                                                                 */
        if (!this.isPaused) {
            const now = Date.now();
            const currentSessionDuration = this.pauseTime ? now - this.pauseTime : now - this.startTime;
            totalDuration += currentSessionDuration;
        }

        /*                                                  */
        const durationInSeconds = Math.floor(totalDuration / 1000);
        const currentProductsCount = this.productsCount;

        /*          */
        this.reset();

        return [durationInSeconds, currentProductsCount || undefined];
    }

    /**
 *
 *
 *
 */
    getCurrentDuration(): number {
        if (!this.startTime) {
            return 0;
        }

        let totalDuration = this.accumulatedDuration;

        if (!this.isPaused) {
            const now = Date.now();
            const currentSessionDuration = this.pauseTime ? now - this.pauseTime : now - this.startTime;
            totalDuration += currentSessionDuration;
        }

        return Math.floor(totalDuration / 1000);
    }

    /**
 *
 */
    private reset(): void {
        this.startTime = null;
        this.pauseTime = null;
        this.accumulatedDuration = 0;
        this.productsCount = null;
        this.isPaused = false;
    }

    /**
 *
 *
 */
    setProductsCount(count: number): void {
        this.productsCount = count;
    }

    /**
 *
 *
 */
    getProductsCount(): number | undefined {
        return this.productsCount || undefined;
    }

    /**
 *
 */
    isActive(): boolean {
        return this.startTime !== null;
    }
}

/*                        */
export const voiceTracker = new VoiceTracker();

